<template>
  <div v-if="previewRoute" class="static_page_preview_link">
    <router-link :to="previewRoute" class="preview_btn">
      <i class="fas fa-external-link-alt"></i>
      {{ $t("STATIC_PAGES.previewPage") }}
    </router-link>
  </div>
</template>

<script>
import { STATIC_PAGES } from "@/services/generalApi";

export default {
  name: "StaticPagePreviewLink",

  props: {
    pageKey: {
      type: String,
      required: true,
    },
  },

  computed: {
    previewRoute() {
      return STATIC_PAGES[this.pageKey]?.route || null;
    },
  },
};
</script>

<style lang="scss" scoped>
.static_page_preview_link {
  margin-bottom: 1rem;
}

.preview_btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #ef3405;
  font-weight: 600;
}
</style>
